import * as React from 'react';
import {
  ArticleContentWithSidebar, ArticleLanguageRedirect, ArticleNotFound, ArticleSearch,
} from './components';
import { Authentified } from '../../../../../Auth';
import { useSanityNewsByUrlId } from '../../../../../../sanity';
import { ChartLoader } from '../../../../../chartLoader';

export const NewsArticle = () => {
  const {
    data,
    isLoading,
  } = useSanityNewsByUrlId();
  if (isLoading) {
    return (
      <ChartLoader
        widthLines={['1/3', undefined, undefined, '1/12', undefined, undefined]}
        lines={['1/3', undefined, undefined, '1/12', undefined, undefined]}
      />
    );
  }
  if (data == null) {
    return <ArticleNotFound />;
  }
  return (
    <>
      <ArticleLanguageRedirect />
      <Authentified
        withText={false}
        canClose
        initialClosed
      >
        <ArticleContentWithSidebar />
        <ArticleSearch />
      </Authentified>
    </>
  );
};
